import { useQuery } from "@tanstack/react-query"
import { useEffect } from "react"
import { getQuestsWaitlist } from "@/lib/api/quests"
import { useQuestsStore } from "@/lib/store/quests"
import { queryKeys } from "@/lib/utils/query"
import { WaitlistResponse } from "@/types/quests"

export const useWaitlists = (isAuthenticated: boolean) => {
  const { waitlists, setWaitlists } = useQuestsStore()

  const {
    data: waitlistsData,
    isLoading: isLoadingWaitlists,
    error: waitlistsError,
  } = useQuery<WaitlistResponse>({
    queryKey: queryKeys.waitlists,
    queryFn: getQuestsWaitlist,
    enabled: isAuthenticated,
    staleTime: 1000 * 60 * 5,
    gcTime: 1000 * 60 * 10,
  })

  useEffect(() => {
    if (waitlistsData?.results) {
      setWaitlists(waitlistsData.results)
    }
  }, [waitlistsData, setWaitlists])

  return {
    waitlists,
    loading: isLoadingWaitlists,
    error: waitlistsError,
  }
}